import React from 'react';
import img2 from '../images/Instruction for correct pose during office work.jpg';
import Container from 'react-bootstrap/Container';
import { BsFacebook, BsTwitter, BsLinkedin, BsInstagram } from "react-icons/bs"; 
import { SiBehance, } from 'react-icons/si'; 
// import { FaPinterestP } from "react-icons/fa";
export default function Section6() {
  return (
    <section id='Contact'>
        <div className='row section2'> 
            <Container>
                <div className='justify-content-center text-center p-2'> 
                    <h1>Contact<br /></h1>
                    <h3>FIND ME ON</h3>
                </div> 
                <footer class="page-footer"> 
                <div class="container"> 
                    <div class="row "> 
                        <div className="col-sm-12 col-gap-2 icon p-4">
                            <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <SiBehance value={{ color: 'black' }} />   
                                </a>
                            </div>
                            <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <BsLinkedin value={{ color: 'black' }} />   
                                </a>
                            </div> 
                            <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <BsFacebook value={{ color: 'black' }} />   
                                </a>
                            </div> 
                            {/* <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <SiDiscord value={{ color: 'black' }} />   
                                </a>
                            </div>  */}
                            <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <BsInstagram value={{ color: 'black' }} />   
                                </a>
                            </div> 
                             {/* <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <FaPinterestP value={{ color: 'black' }} />   
                                </a>
                            </div>  */}
                            <div className="circle">
                                <a href="facebook.com" className="icon">
                                    <BsTwitter value={{ color: 'black' }} />   
                                </a>
                            </div>    
                        </div>     
                    </div> 
                </div>    
                <div className=' mx-auto' style={{
                    width:"50%", height:"50%"
                }}>
                    <img src={img2} alt="" />
                </div>
                <div class="footer-copyright text-center ">© 2022 Portfolio  
                    <a href="#AyzaKhan">Ayza Khan</a>
                </div> 
                </footer> 
            </Container>
        </div> 
    </section>
  )
}
